// extracted by mini-css-extract-plugin
export var card = "_8e-1";
export var container = "_8e-0";